import { IndepthClients } from '@constants/clients';

export function getIsClientAllowedHeatmap(client: string) {
    const allowedClients = [IndepthClients.inkyfada, IndepthClients.dev];

    return allowedClients.includes(client);
}
